// These intent values intentionally mirror the route-level navigation handler
// (MY_GOUSTO_INTENTS in the webclient app); keep the string values in sync.
export const CONTROL_VIEW_CTA_INTENTS = {
  resubscribe: 'reactivate_subscription',
  orderOneOffBox: 'start_one_off_order',
} as const

export type ControlViewCtaIntent =
  typeof CONTROL_VIEW_CTA_INTENTS[keyof typeof CONTROL_VIEW_CTA_INTENTS]

export type ControlViewCtaAction = {
  intent: ControlViewCtaIntent
  label: string
}

export type ControlViewCta = {
  heading: string
  subheading: string
  action: ControlViewCtaAction
}

export const CONTROL_VIEW_CTAS: ControlViewCta[] = [
  {
    heading: 'Back for more?',
    subheading:
      'Weekly, Fortnightly or Monthly - pick a subscription cadence that works for you and ' +
      "get started again whenever you're ready.",
    action: { intent: CONTROL_VIEW_CTA_INTENTS.resubscribe, label: 'Resubscribe' },
  },
  {
    heading: 'Just want one box?',
    subheading:
      'No commitment needed. Browse our recipes and order a one-off box whenever you fancy!',
    action: { intent: CONTROL_VIEW_CTA_INTENTS.orderOneOffBox, label: 'Order a one-off box' },
  },
]
